// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"66b74242","239":"f86aa320","453":"16da5b46","455":"930273d3","977":"871e4b88"}[chunkId] + ".chunk.js";
};